const legal_booking_en = 
`
I, the undersigned, having acquired the information contained in the Privacy Policy referred to in the art. 13, EU
Regulation 679/2016 (“GDPR”) and having read the [**information**](https://firaftbooking.it/terms/utenti-prenotazione), agree to my personal data processing, enclosing the data of the other people included in the reservation, according to
the procedures and purposes specified in point 1) of this privacy policy, closely related and instrumental to the
application of the booking request. ([**information “Member Amateur-Tourists”).**](https://firaftbooking.it/terms/tesserati-turisti-amatori)).
`;

module.exports =legal_booking_en;
